<template>

    <section class="dd-m-banner dd-m-banner--small">

        <loading type="banner" v-if="isLoading"></loading>

        <div class="dd-l-container__wrapper dd-l-container__wrapper--full dd-l-container__wrapper--full-custom" v-if="data">
            <div class="dd-m-banner--small__container">
                <!-- <h2 class="dd-m-banner--small__title">{{ data.title }}</h2> -->

                <div class="dd-m-banner--small__content">
                    <div class="dd-m-banner--small__info">
                        <div class="dd-m-banner--small__description">
                            {{ data.description }}
                        </div>

                        <a class="dd-m-button dd-m-button--auto dd-m-button--pink"
                           :title="data.title"
                           :target="data.target === 1 ? '_self' : '_blank'"
                           :href="data.link">
                            {{ data.textbutton }}
                        </a>
                    </div>

                    <picture class="dd-m-banner--small__img" style='width: 100%'>
                        <source :srcset="data.image.desktop" media="(min-width: 1280px)">
                        <source :srcset="data.image.tablet" media="(min-width: 768px)">
                        <img :srcset="data.image.mobile" :alt="data.title">
                    </picture>
                </div>
            </div>
        </div>
    </section>

</template>
<script>
    import BannerService from '../../providers/api/banner-service';
    import Loading from "../loading";

    const api = new BannerService();

    export default {
        name: 'banner-small',
        components: {Loading},
        props: [],
        mounted() {
            this.getData();
        },
        data: () => {
            return {
                data: null,
                isLoading: false
            }
        },
        methods: {
            getData() {
                this.isLoading = true;
                api.doGetSmall(1)
                    .then((res) => {
                        if (res.data.data.length) {
                            this.data = res.data.data[0];
                        }

                        this.isLoading = false;
                    })
                    .catch(() => this.isLoading = false);
            }
        }
    }
</script>



// WEBPACK FOOTER //
// resources/site/js/components/banners/banner-small.vue